import React from "react";
import searcher from "../../assets/icons/searchInput.svg";
import back from "../../assets/icons/back.svg";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import FaqVersionTable from "./faq-version-list-table";

const FaqVersionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  return (
    <MainLayout breadCrumb="ADMIN / FAQ’s / Version History">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="d-flex w-100">
            <div
              className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
              onClick={() => navigate("/faq")}
            >
              <img src={back} alt="back_btn" />
              <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                BACK
              </span>
            </div>
            <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
              <img className="styled-SVG" src={searcher} color={""} />
              <input
                value={search}
                className="search-input fs_14 fw_400 px-2 text-dark"
                type="text"
                placeholder="Search FAQ's here by FAQ ID, FAQ Questions..."
                onChange={(e) =>
                  navigate(
                    `/faq/version-list?page=1${
                      e.target.value ? `&search=${e.target.value}` : ""
                    }`
                  )
                }
              />
            </div>
          </div>
        </div>
        <FaqVersionTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default FaqVersionList;
